import React, { Component } from 'react';
import { formatVietnameseDate, isValidDate } from '@/utils/helpers';

class PrintOrthoPlan extends Component {

    render() {
        const { customer, data } = this.props;

        const created_at = data?.created_at || '';
        const doctor = data?.doctor?.full_name || '';
        const hang_mat = data?.a?.hang_mat || '';
        const kich_thuoc_xuong_ham_tren = data?.a?.kich_thuoc_xuong_ham_tren || '';
        const kich_thuoc_xuong_ham_duoi = data?.a?.kich_thuoc_xuong_ham_duoi || '';
        const tuong_quan_r6_phai = data?.a?.tuong_quan_r6_phai || '';
        const tuong_quan_r6_phai_mm = data?.a?.tuong_quan_r6_phai_mm || '';
        const tuong_quan_r6_trai = data?.a?.tuong_quan_r6_trai || '';
        const tuong_quan_r6_trai_mm = data?.a?.tuong_quan_r6_trai_mm || '';
        const tuong_quan_r3_phai = data?.a?.tuong_quan_r3_phai || '';
        const tuong_quan_r3_phai_mm = data?.a?.tuong_quan_r3_phai_mm || '';
        const tuong_quan_r3_trai = data?.a?.tuong_quan_r3_trai || '';
        const tuong_quan_r3_trai_mm = data?.a?.tuong_quan_r3_trai_mm || '';
        const can_chia = data?.a?.can_chia || '';
        const can_nguc_rang_cua_nanh = data?.a?.can_nguc_rang_cua_nanh || '';
        const can_nguc_rang_cua_nanh_tai_rang = data?.a?.can_nguc_rang_cua_nanh_tai_rang || '';
        const tieng_keu_bat_thuong = data?.a?.tieng_keu_bat_thuong || '';

        const xu_huong_phat_trien = data?.b?.xu_huong_phat_trien || '';
        const cant_mat_phang_ham_tren = data?.b?.cant_mat_phang_ham_tren || '';
        const tuong_quan_rang_cua = data?.b?.tuong_quan_rang_cua || '';
        const can_trum_ho = data?.b?.can_trum_ho || '';
        const duong_cuoi = data?.b?.duong_cuoi || '';
        const cuoi_ho_loi = data?.b?.cuoi_ho_loi || '';
        const cuoi_ho_loi_tu_rang = data?.b?.cuoi_ho_loi_tu_rang || '';
        const cuoi_ho_loi_den_rang = data?.b?.cuoi_ho_loi_den_rang || '';
        const cung_cuoi = data?.b?.cung_cuoi || '';
        const mat_phang_nhai = data?.b?.mat_phang_nhai || '';
        const ha_ngam_toi_da = data?.b?.ha_ngam_toi_da || '';
        const x_ray_tieu_loi = data?.b?.x_ray_tieu_loi || '';
        const xuong_ham_tren = data?.c?.xuong_ham_tren || '';
        const xuong_ham_duoi = data?.c?.xuong_ham_duoi || '';
        const duong_giua_ham_tren_mat = data?.c?.duong_giua_ham_tren_mat || '';
        const duong_giua_ham_tren_mat_muc_do_lech = data?.c?.duong_giua_ham_tren_mat_muc_do_lech || '';
        const duong_giua_ham_duoi_mat = data?.c?.duong_giua_ham_duoi_mat || '';
        const duong_giua_ham_duoi_mat_muc_do_lech = data?.c?.duong_giua_ham_duoi_mat_muc_do_lech || '';
        const can_cheo_rang_ham = data?.c?.can_cheo_rang_ham || '';
        const can_cheo_rang_ham_tai_rang = data?.c?.can_cheo_rang_ham_tai_rang || '';
        const can_cat_keo_rang_ham = data?.c?.can_cat_keo_rang_ham || '';
        const can_cat_keo_rang_ham_tai_rang = data?.c?.can_cat_keo_rang_ham_tai_rang || '';
        const thua_khoang_thieu_khoang_ham_tren = data?.c?.thua_khoang_thieu_khoang_ham_tren || '';
        const thua_khoang_thieu_khoang_ham_duoi = data?.c?.thua_khoang_thieu_khoang_ham_duoi || '';

        const phac_do_dieu_tri_de_nghi = data?.phac_do_dieu_tri_de_nghi || '';

        const treatment_goals = data?.treatment_goals || {};

        const addressParts = [
            customer?.address?.trim(),
            customer?.hamlet?.trim(),
            customer?.wards_name?.trim(),
            customer?.province_name?.trim(),
        ];

        // Lọc bỏ phần rỗng hoặc undefined, rồi nối bằng dấu phẩy
        const address = addressParts.filter(Boolean).join(', ') || '-';


        /**
         * Hiển thị giá trị nếu có, ngược lại trả về fallback (mặc định là '-')
         * Nếu có suffix và value có giá trị → hiển thị cả value + suffix
         * Nếu không có value → chỉ hiển thị fallback
         */
        const displayValue = (value, suffix = '') => {
            const hasValue = value !== null && value !== undefined && value !== '';

            if (hasValue) {
                // Nếu có suffix, hiển thị cả value và suffix
                return suffix ? `${value} ${suffix}` : `${value}`;
            }

            // Nếu không có value, chỉ hiển thị fallback (không có suffix)
            return null;
        };

        return (
            <div className="container print-content">

                <div className="header">
                    <div className="logo-box">
                        <img src="https://chingodental.vn/Logo-fanpage-2.png" alt="Logo Chingo Dental" />
                    </div>

                    <div className="footer">
                        <div className="qr-box">
                            <img src="https://chingodental.vn/QRCode.jpg" alt="QR Code" />
                        </div>

                        <div className="clinic">
                            <div className="section-title">NHA KHOA CHINGO</div>
                            <span>CS1: Số 560 Nguyễn Văn Cừ, Phường Bồ Đề, TP. Hà Nội</span>
                            <span>Hotline: 0978 009 780</span>
                            <span>CS2: Số 22 Lê Hồng Phong, Phường Hải Châu, TP. Đà Nẵng</span>
                            <span>Hotline: 0916 019 696</span>
                            <span>CS3: Số 17 Lý Nam Đế, Phường Hội An, TP. Đà Nẵng</span>
                            <span>Hotline: 0916 019 696</span>
                        </div>
                    </div>
                </div>

                <div className="title-wrap">
                    <h1>BỆNH ÁN CHỈNH NHA</h1>
                </div>


                <h2 className="section-title">THÔNG TIN KHÁCH HÀNG</h2>
                <table className="kv-table mb-4">
                    <tr>
                        <th>Họ và tên khách hàng</th>
                        <td><strong>{customer?.full_name}</strong></td>
                    </tr>
                    <tr>
                        <th>Mã khách hàng</th>
                        <td>{customer?.code}</td>
                    </tr>
                    <tr>
                        <th>Số CCCD/CMND</th>
                        <td>{customer?.identity_number}</td>
                    </tr>
                    <tr>
                        <th>Ngày sinh</th>
                        <td>{isValidDate(customer?.birthday, false)}</td>
                    </tr>
                    <tr>
                        <th>Tuổi</th>
                        <td>{customer?.age}</td>
                    </tr>
                    <tr>
                        <th>Địa chỉ</th>
                        <td>{address}</td>
                    </tr>
                </table>


                <h2 className="section-title">PHẦN 1: CHẨN ĐOÁN</h2>
                <table className="custom-table">
                    <thead>
                        <tr>
                            <th />
                            <th>
                                Chiều trước - sau<sup>(A)</sup>
                            </th>
                            <th>
                                Chiều dọc<sup>(B)</sup>
                            </th>
                            <th>
                                Chiều ngang<sup>(C)</sup>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* XƯƠNG */}
                        <tr>
                            <td className="section-title">
                                Xương<sup>(I)</sup>
                            </td>
                            <td>
                                <div className="section-subtitle">• <strong>Hạng mặt<sup>(1)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(hang_mat)}</div>

                                <div className="section-subtitle">• <strong>Kích thước xương hàm trên<sup>(2)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(kich_thuoc_xuong_ham_tren)}</div>

                                <div className="section-subtitle">• <strong>Kích cỡ xương hàm dưới<sup>(3)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(kich_thuoc_xuong_ham_duoi)}</div>
                            </td>
                            <td>
                                <div className="section-subtitle">• <strong>Xu hướng phát triển<sup>(1)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(xu_huong_phat_trien)}</div>

                                <div className="section-subtitle">• <strong>Cant mặt phẳng hàm trên<sup>(2)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(cant_mat_phang_ham_tren)}</div>
                            </td>
                            <td>
                                <div className="section-subtitle">• <strong>Xương hàm trên<sup>(1)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(xuong_ham_tren)}</div>

                                <div className="section-subtitle">• <strong>Xương hàm dưới<sup>(2)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(xuong_ham_duoi)}</div>
                            </td>
                        </tr>
                        {/* RĂNG */}
                        <tr>
                            <td className="section-title">
                                Răng<sup>(II)</sup>
                            </td>
                            <td>
                                <div className="section-subtitle">• <strong>Tương quan R6 (Phải)<sup>(1)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(tuong_quan_r6_phai)} {displayValue(tuong_quan_r6_phai_mm, 'mm')}</div>

                                <div className="section-subtitle">• <strong>Tương quan R6 (Trái)<sup>(2)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(tuong_quan_r6_trai)} {displayValue(tuong_quan_r6_trai_mm, 'mm')}</div>

                                <div className="section-subtitle">• <strong>Tương quan R3 (Phải)<sup>(3)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(tuong_quan_r3_phai)} {displayValue(tuong_quan_r3_phai_mm, 'mm')}</div>

                                <div className="section-subtitle">• <strong>Tương quan R3 (Trái)<sup>(4)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(tuong_quan_r3_trai)} {displayValue(tuong_quan_r3_trai_mm, 'mm')}</div>

                                <div className="section-subtitle">• <strong>Cắn chìa<sup>(5)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(can_chia, 'mm')}</div>

                                <div className="section-subtitle">• <strong>Cắn ngược răng cửa / nanh<sup>(6)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(can_nguc_rang_cua_nanh)}</div>
                                <div className="section-subtitle">• <strong>Tại răng:</strong> {displayValue(can_nguc_rang_cua_nanh_tai_rang)}</div>
                            </td>
                            <td>
                                <div className="section-subtitle">• <strong>Tương quan răng cửa<sup>(1)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(tuong_quan_rang_cua)}</div>

                                <div className="section-subtitle">• <strong>Cắn trùm / hở<sup>(2)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(can_trum_ho)}</div>

                                <div className="section-subtitle">• <strong>Đường cười<sup>(3)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(duong_cuoi)}</div>

                                <div className="section-subtitle">• <strong>Cười hở lợi<sup>(4)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(cuoi_ho_loi, 'mm')}</div>

                                <div className="section-subtitle">• <strong>Từ răng<sup>(5)</sup>:</strong> {displayValue(cuoi_ho_loi_tu_rang)}</div>

                                <div className="section-subtitle">• <strong>Đến răng:</strong> {displayValue(cuoi_ho_loi_den_rang)}</div>
                                <div className="section-subtitle">• <strong>Cung cười<sup>(6)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(cung_cuoi)}</div>

                                <div className="section-subtitle">• <strong>Mặt phẳng nhai<sup>(8)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(mat_phang_nhai)}</div>
                            </td>
                            <td>
                                <div className="section-subtitle">• <strong>Đường giữa hàm trên so với đường giữa mặt<sup>(1)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(duong_giua_ham_tren_mat)}</div>

                                <div className="section-subtitle">• <strong>Mức độ lệch<sup>(2)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(duong_giua_ham_tren_mat_muc_do_lech)}</div>

                                <div className="section-subtitle">• <strong>Đường giữa hàm dưới so với đường giữa mặt<sup>(3)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(duong_giua_ham_duoi_mat)}</div>

                                <div className="section-subtitle">• <strong>Mức độ lệch<sup>(4)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(duong_giua_ham_duoi_mat_muc_do_lech, 'mm')}</div>

                                <div className="section-subtitle">• <strong>Cắn chéo răng hàm<sup>(5)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(can_cheo_rang_ham)}</div>

                                <div className="section-subtitle">• <strong>Tại răng:</strong> {displayValue(can_cheo_rang_ham_tai_rang)}</div>

                                <div className="section-subtitle">• <strong>Cắn cắt kéo răng hàm<sup>(6)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(can_cat_keo_rang_ham)}</div>
                                <div className="section-subtitle">• <strong>Tại răng:</strong> {displayValue(can_cat_keo_rang_ham_tai_rang)}</div>

                                <div className="section-subtitle">• <strong>Thừa khoảng / thiếu khoảng hàm trên<sup>(7)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(thua_khoang_thieu_khoang_ham_tren)}</div>

                                <div className="section-subtitle">• <strong>Thừa khoảng / thiếu khoảng dưới<sup>(8)</sup>:</strong></div>
                                <div className='mb-2'>{displayValue(thua_khoang_thieu_khoang_ham_duoi)}</div>
                            </td>
                        </tr>
                        {/* CHỨC NĂNG */}
                        <tr>
                            <td className="section-title">
                                Chức năng<sup>(III)</sup>:
                            </td>
                            <td colSpan={3}>
                                <div className="section-subtitle"><strong>Khớp thái dương hàm</strong></div>
                                <div className="section-subtitle">• <strong>Tiếng kêu bất thường<sup>(1)</sup>:</strong> {displayValue(tieng_keu_bat_thuong)}</div>
                                <div className="section-subtitle">• <strong>Há / ngậm tối đa<sup>(2)</sup>:</strong> {displayValue(ha_ngam_toi_da)}</div>
                                <div className="section-subtitle">• <strong>X-ray tiêu lùi<sup>(3)</sup>:</strong> {displayValue(x_ray_tieu_loi)}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                {treatment_goals && treatment_goals.length > 0 && (
                    <>
                        <h2 className="section-title">PHẦN 2: MỤC TIÊU ĐIỀU TRỊ</h2>
                        <table className="custom-table">
                            <thead>
                                <tr>
                                    <th width="40%">Vấn đề cần khắc phục</th>
                                    <th>Ghi chú</th>
                                </tr>
                            </thead>
                            <tbody>
                                {treatment_goals.map((goal) => (
                                    <tr key={goal.id} style={{ textAlign: 'left' }}>
                                        <td>{goal.issue || '-'}</td>
                                        <td>{goal.note || '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </>
                )}

                {phac_do_dieu_tri_de_nghi && (<>
                    <h2 className="section-title">PHẦN 3: PHÁC ĐỒ ĐIỀU TRỊ CHỈNH NHA ĐỀ NGHỊ</h2>
                    <div className="mb-2">{phac_do_dieu_tri_de_nghi}</div>
                </>)}


                <div className="print-date">
                    .............., ngày {formatVietnameseDate(created_at)}
                </div>


                <div className="signature-section mt-4">
                    <div className="sig-box">
                        <strong>Bác sĩ</strong>
                        <span className="note">(Ký, ghi rõ họ tên)</span>
                        <div className="sig-space"></div>
                        <div className="sig-name">{doctor}</div>
                    </div>

                    <div className="sig-box">
                        <strong>Khách hàng</strong>
                        <span className="note">(Ký, ghi rõ họ tên)</span>
                        <div className="sig-space"></div>
                        <div className="sig-name">{customer?.full_name}</div>
                    </div>
                </div>

                <style>
                    {`
                        /* --- Print & Page setup --- */
                        @page {
                            size: A4;
                            margin: 1cm 1.5cm 1.8cm 1.8cm;
                            /* top right bottom left */
                        }

                        :root {
                            --text: #111;
                            --muted: #666;
                            --border: #ddd;
                            --heading: #000;
                            --primary: #0b2b33;
                        }

                        @media print {
                            .no-print {
                                display: none !important;
                            }

                            .page-break {
                                page-break-before: always;
                            }

                            body {
                                font-family: "Times New Roman", serif;
                                font-size: 12pt;
                                line-height: 1.5;
                                color: #000;
                               /*  width: 210mm;
                                border: 1px solid #dedede; */
                            }
                        }

                        .container {
                            max-width: 800px;
                            margin: 0 auto;
                            padding: 0;
                            position: relative;
                        }

                        .print-content h1,
                        .print-content h2,
                        .print-content h3 {
                            margin: 0 0 10px 0;
                            color: var(--heading);
                        }

                        .print-content h1 {
                            text-align: center;
                            font-size: 18pt;
                            letter-spacing: 0.3px;
                        }

                        .print-content h2.section-title {
                            font-size: 13.5pt;
                            /* border-left: 4px solid var(--primary);
                            padding-left: 8px; */
                            margin: 18px 0 10px 0;
                        }

                        .print-content .line-height-20{
                            line-height: 20px;
                        }
                        .subtitle {
                            color: var(--muted);
                            font-style: italic;
                            font-weight: normal;
                            margin-left: 6px;
                            font-size: 11.5pt;
                        }

                        /* --- Header --- */
                    .header {
                        display: flex;
                        align-items: flex-start;
                        justify-content: space-between;
                        margin-bottom: 20px;
                        border-bottom: 1px solid var(--border);
                        padding-bottom: 20px;
                        position: relative;
                    }

                    /* Nhóm bên phải (QR + thông tin) */
                    .header .footer {
                        display: flex;
                        align-items: flex-start;
                        gap: 16px;
                        border: none;
                        padding-top: 0;
                        margin-top: 0;
                    }

                    /* Logo */
                    .logo-box {
                        width: 90px;
                        height: 90px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;
                    }

                    .logo-box img {
                        max-width: 100%;
                        max-height: 100%;
                        object-fit: contain;
                    }

                    /* QR */
                    .header .footer .qr-box {
                        width: 80px;
                        height: 80px;
                        flex-shrink: 0;
                    }

                    .header .footer .qr-box img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                        border: 1px solid var(--border);
                        background: #fff;
                        padding: 4px;
                    }

                    /* Clinic info */
                    .header .footer .clinic {
                        text-align: left;
                        margin-left: 8px;
                        font-size: 10.5pt;
                        line-height: 1.4;
                    }

                    .header .footer .clinic .section-title {
                        font-weight: bold;
                        color: var(--primary);
                        margin-bottom: 4px;
                        font-size: 11pt;
                    }

                    .header .footer .clinic span {
                        display: block;
                        font-size: 8px;
                        color: var(--muted);
                        line-height: 1.3;
                    }
                        .title-wrap {
                            margin: 8px 0 16px 0;
                        }

                        /* --- Tables --- */
                        table {
                            border-collapse: collapse;
                            width: 100%;
                        }

                        .kv-table td,
                        .kv-table th {
                            border: 0px solid var(--border);
                            padding: 5px 0px;
                            vertical-align: top;
                        }

                        .kv-table th {
                            width: 32%;
                            /* background: #fafafa; */
                            text-align: left;
                            font-weight: 600;
                        }

                        .grid-table th,
                        .grid-table td {
                            border: 1px solid var(--border);
                            padding: 6px 8px;
                            vertical-align: top;
                        }

                        .grid-table th {
                            background: #fafafa;
                        }

                        .narrow td,
                        .narrow th {
                            padding: 5px 6px;
                        }

                        .muted {
                            color: var(--muted);
                        }

                        /* --- Helpers --- */
                        .mb-4 {
                            margin-bottom: 16px;
                        }

                        .mb-2 {
                            margin-bottom: 8px;
                        }

                        .mt-2 {
                            margin-top: 8px;
                        }

                        .mt-4 {
                            margin-top: 16px;
                        }

                        .pt-2 {
                            padding-top: 8px;
                        }

                        .pt-4 {
                            padding-top: 16px;
                        }

                        .pl-2 {
                            padding-left: 8px;
                        }

                        .pl-4 {
                            padding-left: 16px;
                        }

                        .pr-2 {
                            padding-right: 8px;
                        }

                        .pr-4 {
                            padding-right: 16px;
                        }

                        .italic {
                            font-style: italic;
                        }

                        .center {
                            text-align: center;
                        }

                        .right {
                            text-align: right;
                        }

                        .checkbox {
                            font-family: "Segoe UI Symbol", "DejaVu Sans", "Times New Roman";
                        }

                        .note {
                            color: var(--muted);
                        }

                        .image-strip {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 8px;
                            border: 1px dashed var(--border);
                            padding: 10px;
                            min-height: 48px;
                        }

                        .image-thumb {
                            width: 110px;
                            height: 85px;
                            border: 1px solid var(--border);
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 10pt;
                            color: var(--muted);
                            background: #fff;
                        }

                        /* --- Textareas-like blocks --- */
                        .textblock {
                            min-height: 64px;
                            border: 1px solid var(--border);
                            padding: 8px;
                            white-space: pre-wrap;
                        }

                        .textblock.tall {
                            min-height: 96px;
                        }

                        .disease-grid {
                            display: flex;
                            gap: 16px;
                            justify-content: space-between;
                        }

                        .disease-column {
                            flex: 1;
                        }

                        .disease-column table {
                            width: 100%;
                        }

                        .disease-column td strong {
                            margin-right: 4px;
                            color: var(--primary);
                        }

                        @media print {
                            .disease-grid {
                                page-break-inside: avoid;
                            }
                        }

                        .bite-item {
                            justify-content: space-between;
                            padding: 6px 0;
                        }

                        .bite-item:last-child {
                            border-bottom: none;
                        }

                        .bite-label {
                            flex: 1;
                            color: var(--text);
                        }

                        .bite-value {
                            min-width: 60px;
                            text-align: right;
                            font-weight: bold;
                            color: var(--primary);
                        }

                        .section-subtitle {
                            font-size: 12.5pt;
                            margin-bottom: 6px;
                        }

                        .print-date {
                            text-align: right;
                            margin-top: 40px;
                            font-size: 12pt;
                            font-style: italic;
                            color: var(--text);
                        }

                        .signature-section {
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-start;
                            margin-top: 30px;
                            text-align: center;
                            gap: 60px;
                            margin-bottom: 50px;
                        }

                        .sig-box {
                            flex: 1;
                        }

                        .sig-box strong {
                            font-size: 13pt;
                            display: block;
                            margin-bottom: 2px;
                        }

                        .sig-box .note {
                            color: var(--muted);
                            font-style: italic;
                            font-size: 11pt;
                        }

                        .sig-space {
                            height: 60px;
                            margin: 24px auto 8px auto;
                            width: 80%;
                        }

                        .sig-name {
                            font-weight: bold;
                            font-size: 12pt;
                            color: var(--primary);
                            text-transform: uppercase;
                        }
                        
                         .custom-table {
                            border-collapse: collapse;
                            width: 100%;
                            margin: 10px auto 40px auto;
                            background-color: #fff;
                        }

                        .custom-table .section-subtitle{
                            font-size: 11.5pt;
                        }

                        .custom-table td:first-child {
                            vertical-align: middle;
                            font-weight: bold;
                            width: 10%;
                        }

                        .custom-table th,
                        .custom-table td {
                            border: 1px solid #ccc;
                            padding: 10px 12px;
                            vertical-align: top;
                            text-align: left;
                        }

                        .custom-table th {
                            text-align: center;
                        }

                        .custom-table  sup {
                            font-size: 0.7em;
                            color: #555;
                    }

                    `}
                </style>
            </div >
        );
    }
}

export default PrintOrthoPlan;
